var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffStep6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.973,
    height: 61,
    viewBox: "0 0 48.973 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3735a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a3da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "off",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.065,21.454H8.353a2.8,2.8,0,0,1-2.784-2.8V13.9A4.665,4.665,0,0,0,9.281,9.328V7.462A1.863,1.863,0,0,0,7.425,5.6V.933a.928.928,0,1,0-1.857,0V5.6H3.712V.933a.928.928,0,1,0-1.856,0V5.6A1.862,1.862,0,0,0,0,7.462V9.328A4.664,4.664,0,0,0,3.712,13.9v4.758a4.659,4.659,0,0,0,4.641,4.664h3.758a1.7,1.7,0,0,0,.08.423C12.246,23.742,12.065,21.454,12.065,21.454Z",
    transform: "translate(5.099 30.867)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M6,0H19.593a6,6,0,0,1,6,6V55a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(17.53)",
    fill: "#e2e4e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 19.743,
    height: 53.651,
    rx: 2,
    transform: "translate(20.455 3.675)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(0 45.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.129,4.439a.24.24,0,0,0-.209-.122H3.775L4.3.268A.241.241,0,0,0,3.86.11L.036,6.844a.242.242,0,0,0,.2.368h3.1L2.92,11.267a.241.241,0,0,0,.445.148L7.126,4.682a.242.242,0,0,0,0-.243Z",
    fill: "#00a3da"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M25.593,26.973H2.767a4.031,4.031,0,1,1,0-8.062h8.789a1.106,1.106,0,0,0,0-2.211H2.44a3.7,3.7,0,1,1,0-7.4h8.731a1.493,1.493,0,0,0,0-2.985H2.517a3.78,3.78,0,1,1,0-7.559H25.593v2.5H2.517a1.28,1.28,0,0,0,0,2.559h8.654a3.993,3.993,0,1,1,0,7.985H2.44a1.2,1.2,0,1,0,0,2.4h9.116a3.606,3.606,0,1,1,0,7.212H2.767a1.531,1.531,0,0,0,0,3.062H25.593Z",
    transform: "translate(23.38 8.819)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffStep6);
export default __webpack_public_path__ + "static/media/off-step6.fd4b6371b43bb2e8c7fa427d39195850.svg";
export { ForwardRef as ReactComponent };